import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ApiGatewayService, AuthService, OktaService } from '@drc-eca/eca-components-lib';
import { faBell, faFlag, faUser } from '@fortawesome/free-solid-svg-icons';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  @Input() navState: any;
  logoUrl = 'assets/Logo.jpg';
  bellIcon = faBell;
  userIcon = faUser;
  feedbackIcon = faFlag;

  selectedYear = 0;
  selectedBrooklyn = '';

  years: Array<number> = [];
  brooklyns: Array<string> = [];
  username = '';
  user$: any;

  constructor(
    private authService: AuthService,
    private router: Router,
    private dialog: MatDialog,
    private apiGatewayService: ApiGatewayService,
    private oktaService: OktaService,
  ) {}

  async ngOnInit() {
    this.setUsername();
    const currentYear = new Date().getFullYear();
    this.selectedYear = currentYear;
    this.years = [];

    for (let year = currentYear, i = 0; i <= 5; i++, year--) {
      this.years.push(year);
    }

    this.brooklyns.push("Morrie's Brooklyn Park [CEN-MSP-01]");
    this.selectedBrooklyn = this.brooklyns[0];
  }

  private async setUsername() {
    this.user$ = await this.authService.getUserInfo().toPromise();
    this.username = this.user$.preferred_username;
  }

  closeNav() {
    this.navState.opened = this.navState.opened ? false : true;
  }

  public async signOut(): Promise<void> {
    this.apiGatewayService.clearCache();
    await this.oktaService.signOut();
    // TODO: Navigate to the signout page.
  }

  openFeedback() {
    const feedbackFormUrl = 'https://app.smartsheet.com/b/form/914bc61fc71948a88b77c70e2b6daf11';
    window.open(feedbackFormUrl, '_blank');
  }
}
